<template>
  <div id="app">
    <br />
    <div>
      <label for="party">指定日期：</label>
      <a-date-picker
        placeholder="请选择日期"
        @change="dateChanged"
      ></a-date-picker>
      <a-button type="primary" icon="download" @click="download"
        >导出数据</a-button
      >
      <a-button
        type="primary"
        icon="download"
        :loading="emotionLoading"
        @click="exportEmotion"
        >导出情绪数据</a-button
      >
    </div>
    <br />
    <a-table :columns="columns" :data-source="data" :loading="loading">
      <template
        v-for="col in ['days', 'plates', 'name', 'symbol']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <template v-if="!record.editable">{{ text }}</template>
          <a-input
            v-else
            style="margin: -5px 0"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.symbol, col)"
          />
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => save(record.symbol)">保存</a>
            <a-popconfirm
              title="确认取消?"
              @confirm="() => cancel(record.symbol)"
            >
              <a>取消</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a @click="() => edit(record.symbol)">编辑</a>
          </span>
        </div>
      </template>
    </a-table>
    <div id="container" />
  </div>
</template>

<script>
import Highcharts, { isNumber } from "highcharts";
import { Parser } from "json2csv";
import { columns } from "./table.js";
import http from "./http.js";

export default {
  data() {
    return {
      columns,
      rowData: [],
      csvData: [],
      data: [],
      updateTime: 0,
      needRedraw: true,
      emotionLoading: false,
      loading: false,
    };
  },
  computed: {
    cacheData: function () {
      return this.data.map((item) => ({ ...item }));
    },
  },
  created: function () {
    Highcharts.time.timezoneOffset = new Date().getTimezoneOffset();
    this.getData();
  },
  methods: {
    handleChange(value, key, column) {
      this.needRedraw = false;
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.symbol)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      this.needRedraw = false;
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.symbol)[0];
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      this.needRedraw = true;
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.symbol)[0];
      const targetCache = newCacheData.filter((item) => key === item.symbol)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
    },
    cancel(key) {
      this.needRedraw = true;
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.symbol)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.symbol)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    createChart(dataArray, updateTime) {
      Highcharts.charts.forEach((chart) => {
        if (chart) {
          chart.destroy();
        }
      });
      const list = document.getElementsByClassName("highcharts-data-table");
      for (var i = 0; i < list.length; i++) {
        list[i].remove();
      }
      // 自适应高度
      var container = document.getElementById("container");
      container.setAttribute(
        "style",
        `height: ${dataArray.length * 20 + 140}px`
      );
      Highcharts.chart("container", {
        chart: {
          type: "bar",
        },
        title: {
          text: "连板图",
        },
        subtitle: {
          text: updateTime
            ? `数据日期: ${Highcharts.dateFormat(
                "%Y-%m-%d",
                updateTime.getTime()
              )}`
            : "",
        },
        xAxis: {
          categories: dataArray.map((data) => {
            let plates = `[${data.plates}]`;
            const name = (data.name || "？？？？")
              .replace(/\s+/g, "")
              .padStart(4, "　");
            const symbol = data.symbol || "??????.??";
            // eslint-disable-next-line no-irregular-whitespace
            return `${plates}　${name}　${symbol}`;
          }),
          title: {
            text: "股票名称",
          },
        },
        yAxis: {
          min: 0,
          allowDecimals: false,
          title: {
            text: "连板数",
            align: "high",
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          valueSuffix: " 天",
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              allowOverlap: true, // 允许数据标签重叠
            },
          },
        },
        series: [
          {
            name: "连板数",
            data: dataArray.map((data) => {
              return Number(data.days);
            }),
          },
        ],
        exporting: {
          showTable: false,
        },
        credits: {
          enabled: false,
        },
      });
    },
    dateChanged(date, dateString) {
      this.getData(dateString);
      console.log(date, dateString);
    },
    download() {
      try {
        const opt = {
          // excelStrings: true,
          withBOM: true,
        };
        const parser = new Parser(opt);
        const csv = parser.parse(this.csvData);
        const time = Highcharts.dateFormat("%m-%d", new Date(this.updateTime));
        this.generateFile(csv, `连板数据(${time}).csv`);
      } catch (err) {
        console.log(err);
        this.$message.error(err);
      }
    },
    async exportEmotion() {
      try {
        this.emotionLoading = true;
        const queryList = [
          "上涨",
          "下跌",
          "上涨>3%",
          "下跌>3%",
          "炸板",
          "涨停",
          "跌停",
          "涨停除ST除新股",
          "跌停除ST",
          "上涨超10%除涨停除新股",
          "下跌超10%除跌停",
        ];

        let csvData = {};
        let queryLength = Infinity;
        let remaining = [...queryList];

        while (remaining.length > 0 && remaining.length < queryLength) {
          queryLength = remaining.length;
          Object.assign(csvData, await this.fetchEmotionData(remaining));
          remaining = queryList.filter(
            (element) => !Object.keys(csvData).includes(element)
          );
        }

        let sortData = {};

        queryList.forEach((question) => {
          sortData[question] =
            typeof csvData[question] === "number" ? csvData[question] : "-";
        });

        const opt = {
          // excelStrings: true,
          withBOM: true,
        };
        const parser = new Parser(opt);
        const csv = parser.parse(sortData);
        const time = Highcharts.dateFormat("%m-%d %H_%M", new Date());
        this.generateFile(csv, `情绪数据(${time}).csv`);
        this.emotionLoading = false;
      } catch (err) {
        console.log(err);
        this.$message.error(err);
        this.emotionLoading = false;
      }
    },
    fetchEmotionData(queryList) {
      const baseUrl =
        "http://www.iwencai.com/unifiedwap/unified-wap/result/get-robot-data?source=ths_mobile_iwencai&version=2.0&secondary_intent=stock&add_info={%22urp%22:{%22scene%22:3,%22company%22:1,%22business%22:1},%22contentType%22:%22json%22}&question=";
      const promises = [];

      return new Promise((resolve) => {
        http
          .post({
            url:
              "https://service-3bu5ple5-1251732481.cd.apigw.tencentcs.com/release/getCookie",
          })
          .then((cookie) => {
            queryList.forEach((query) => {
              const uri = baseUrl + encodeURIComponent(query);
              const headers = {
                Cookie: cookie,
              };
              promises.push(
                new Promise((resolve) => {
                  http
                    .proxy({
                      uri,
                      headers,
                    })
                    .then((data) => resolve(data))
                    .catch(() => resolve(null));
                })
              );
            });

            Promise.all(promises).then((results) => {
              const csvData = {};
              results.forEach((res, index) => {
                let count;
                const data = res && res.data;
                const question = (data && data.question) || queryList[index];
                const answer = data && data.answer && data.answer[0];
                const txt = answer && answer.txt;
                const content = txt && txt[0] && txt[0].content;
                const component =
                  content && content.components && content.components[0];
                if (component && component.show_type === "xuangu_tableV1") {
                  const extra =
                    component &&
                    component.data &&
                    component.data.meta &&
                    component.data.meta.extra;
                  count = extra && (extra.row_count || extra.code_count);
                }
                if (isNumber(count)) {
                  csvData[question] = count;
                }
              });
              resolve(csvData);
            });
          });
      });
    },
    generateFile(content, filename) {
      var eleLink = document.createElement("a");
      eleLink.download = filename;
      eleLink.style.display = "none";
      // 字符内容转变成blob地址
      var blob = new Blob([content]);
      eleLink.href = URL.createObjectURL(blob);
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    formatPrice(n) {
      var t = parseInt(n),
        i,
        r;
      for (
        t = t.toString().replace(/^(\d*)$/, "$1."),
          t = (t + "00").replace(/(\d*\.\d\d)\d*/, "$1"),
          t = t.replace(".", ","),
          i = /(\d)(\d{3},)/;
        i.test(t);

      )
        t = t.replace(i, "$1,$2");
      return (
        (t = t.replace(/,(\d\d)$/, ".$1")),
        (r = t.split(".")),
        r[1] == "00" && (t = r[0]),
        t
      );
    },
    getData(date) {
      var url =
        "https://flash-api.xuangubao.cn/api/pool/detail?pool_name=limit_up";
      if (date) {
        url += `&date=${date}`;
      }
      this.loading = true;
      http
        .get({ url, timeout: 1000 })
        .then((res) => {
          this.loading = false;
          const dataArray = res && res.data;
          this.rowData = dataArray;
          if (!dataArray) {
            this.$message.warning("未查询到结果");
            return;
          }
          var chartDataArray = [];
          var csvDataArray = [];
          var updateTime;
          var maxNum = dataArray.length;
          if (maxNum > 300) {
            maxNum = 300;
          }
          for (let j = 0; j < maxNum; j++) {
            const element = dataArray[j];
            // 提取数据
            const name = element.stock_chi_name;
            const days = element.limit_up_days;
            const symbol = element.symbol;
            let plates =
              element.surge_reason &&
              element.surge_reason.related_plates &&
              element.surge_reason.related_plates.map((plate) => {
                return plate.plate_name;
              });
            plates = plates ? plates.join("、") : "";
            const lastTime = element.last_limit_up;
            if (!updateTime && lastTime) {
              updateTime = new Date(lastTime * 1000);
            }
            const chartData = { days, name, symbol, plates };
            if (
              (plates && plates.includes("ST股")) ||
              (name && name.includes("ST"))
            ) {
              // 过滤ST
              continue;
            }
            var i;
            for (i = 0; i < chartDataArray.length; i++) {
              const currentData = chartDataArray[i];
              if (days > currentData.days) {
                break;
              }
            }
            chartDataArray.splice(i, 0, chartData);
            const reason =
              element.surge_reason && element.surge_reason.stock_reason;
            const price = element.price;
            const change_percent =
              (element.change_percent * 100).toFixed(2) + "%";
            const buy_lock_volume_ratio =
              (element.buy_lock_volume_ratio * 100).toFixed(2) + "%";
            const turnover_ratio =
              (element.turnover_ratio * 100).toFixed(2) + "%";
            const non_restricted_capital = this.formatPrice(
              element.non_restricted_capital
            );
            const total_capital = this.formatPrice(element.total_capital);
            const first_limit_up = Highcharts.dateFormat(
              "%H:%M:%S",
              new Date(element.first_limit_up * 1000)
            );
            const last_limit_up = Highcharts.dateFormat(
              "%H:%M:%S",
              new Date(element.last_limit_up * 1000)
            );
            const break_limit_up_times = element.break_limit_up_times;
            const csvData = {
              名称: name,
              代码: symbol,
              板块: `[${plates}]`,
              理由分析: reason,
              最新价: price,
              涨幅: change_percent,
              封单比: buy_lock_volume_ratio,
              换手率: turnover_ratio,
              "流通市值（元）": non_restricted_capital,
              "总市值（元）": total_capital,
              首次封板: first_limit_up,
              最后封板: last_limit_up,
              开板: break_limit_up_times,
              连板数: days,
            };
            csvDataArray.splice(i, 0, csvData);
          }
          this.needRedraw = true;
          this.updateTime = updateTime;
          this.data = chartDataArray;
          this.csvData = csvDataArray;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("查询失败");
          return;
        });
    },
  },
  watch: {
    data: function (val) {
      if (this.needRedraw) {
        console.log(val);
        this.createChart(val, this.updateTime);
      }
    },
  },
};
</script>

<style>
.chart-outer {
  max-width: 800px;
  margin: 2em auto;
}
#container {
  margin-top: 2em;
  min-width: 380px;
}
.highcharts-table-caption {
  display: none;
}
.highcharts-data-table table {
  border-collapse: collapse;
  border-spacing: 0;
  background: white;
  min-width: 100%;
  margin-top: 10px;
  font-family: sans-serif;
  font-size: 0.9em;
}
.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  border: 1px solid silver;
  padding: 0.5em;
}
.highcharts-data-table tr:nth-child(even),
.highcharts-data-table thead tr {
  background: #f8f8f8;
}
.highcharts-data-table tr:hover {
  background: #eff;
}
.highcharts-data-table caption {
  border-bottom: none;
  font-size: 1.1em;
  font-weight: bold;
}
.highcharts-data-table {
  display: flex;
  align-items: center;
  justify-content: center;
}
.highcharts-data-table table {
  min-width: 0;
}
tbody tr th {
  text-align: end;
}
.editable-row-operations a {
  margin-right: 8px;
}
</style>
